import { useTranslation } from "react-i18next"
import { ReviewFormWrapper } from "./styles"
import { RiHome5Line } from "react-icons/ri"
import { useFormContext } from "react-hook-form"
import { IFormManualReservation } from ".."
import CalendarAdd from "@assets/svg/calendarAdd.svg?react"
import UserOctagonIcon from "@assets/svg/UserOctagonIcon.svg?react"
import MoneysIcon from "@assets/svg/MoneysIcon.svg?react"
import dayjs from "dayjs"
import localizedFormat from "dayjs/plugin/localizedFormat"
import "dayjs/locale/ar"
import "dayjs/locale/en"
dayjs.extend(localizedFormat)
export default function ReviewForm() {
	/* ---------------------------------- Hooks --------------------------------- */
	const { t, i18n } = useTranslation()

	const { getValues } = useFormContext<IFormManualReservation>()
	const propertyName = getValues("booking_information.propertyName")
	const checkIn = getValues("booking_information.checkIn")
	const checkOut = getValues("booking_information.checkOut")
	const firstName = getValues("gust_information.firstName")
	const lastName = getValues("gust_information.lastName")
	const guestPhoneNumber = getValues("gust_information.guestPhoneNumber")
	const nightPrice = getValues("pricing_information.nightPrice")
	const totalPrice = getValues("pricing_information.totalPrice")

	return (
		<ReviewFormWrapper>
			<div className='containerItem'>
				<p>{t("MANUALRESERVATION.REVIEWTHEDATAANDCONFIRMTHERESERVATION")}</p>
			</div>
			<div className='containerItem'>
				<div className='containerSVG'>
					<RiHome5Line />
				</div>
				<p>{t("MANUALRESERVATION.PROPERTYINFORMATION")}</p>
				<p>{propertyName}</p>
			</div>
			<div className='containerItem'>
				<div className='containerSVG'>
					<CalendarAdd />
				</div>
				<p>{t("MANUALRESERVATION.TIMEANDDATEOFRESERVATION")}</p>
				<p>
					{t("MANUALRESERVATION.BOOKINGSTARTDATE")} :{" "}
					{checkIn
						? dayjs(checkIn).locale(i18n.language).format("YYYY MMM DD")
						: ""}
				</p>
				<p>
					{t("MANUALRESERVATION.BOOKINGENDDATE")} :{" "}
					{checkOut
						? dayjs(checkOut).locale(i18n.language).format("YYYY MMM DD")
						: ""}
				</p>
			</div>
			<div className='containerItem'>
				<div className='containerSVG'>
					<UserOctagonIcon />
				</div>
				<p>{t("MANUALRESERVATION.GUESTDATA")}</p>
				<p>
					{firstName} {lastName}
				</p>
				<p>{guestPhoneNumber}</p>
			</div>
			<div className='containerItem'>
				<div className='containerSVG'>
					<MoneysIcon />
				</div>
				<p>{t("COMMON.BOOKING_PRICE_DATA")}</p>
				<p>
					{t("MANUALRESERVATION.NIGHTPRICE")}
					{" : "}
					<span>
						{nightPrice} {t("MANUALRESERVATION.SAR")}
					</span>
				</p>
				<p>
					{t("MANUALRESERVATION.TOTALPRICEOFRESERVATION")}
					{" : "}
					<span>
						{totalPrice} {t("MANUALRESERVATION.SAR")}
					</span>
				</p>
			</div>
		</ReviewFormWrapper>
	)
}
